import { clone } from "@/util/libUtil.js"

import defaultAtencionForm from '@/util/atenciones/defaultAtencionForm.js'
import defaultOfertaForm from './defaultOfertaForm.js'

let defaultAtencionOfertaForm = clone(defaultAtencionForm)
defaultAtencionOfertaForm.oferta = clone(defaultOfertaForm)

export default defaultAtencionOfertaForm;